document.addEventListener('DOMContentLoaded', () => {
  const yearList = document.getElementById('yearList');
  const storySection = document.getElementById('storySection');
  const yearItems = document.querySelectorAll('.year-item');
  const scrollArrow = document.querySelectorAll('.scroll-arrow');
  const storyCards = document.querySelectorAll('.story-card');

  // Show year list only when story section enters viewport
  /*const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          yearList.classList.remove('opacity-0', 'pointer-events-none');
          yearList.classList.add('opacity-100', 'pointer-events-auto');
        } else {
          yearList.classList.add('opacity-0', 'pointer-events-none');
          yearList.classList.remove('opacity-100', 'pointer-events-auto');
        }
      });
    },
    {
      root: null,
      threshold: 0.1,
    }
  );

  if (storySection) {
    observer.observe(storySection);
  }*/

  function activateYear(year) {
    yearItems.forEach((item) => {
      item.classList.toggle('font-bold', item.dataset.year === year);
      item.classList.toggle('active', item.dataset.year === year);
    });
    scrollArrow.forEach((item) => {
      item.classList.toggle('font-bold', item.dataset.year === year);
      item.classList.toggle('active', item.dataset.year === year);
    });
    storyCards.forEach((card) => {
      card.classList.toggle('opacity-100', card.dataset.year === year);
      card.classList.toggle('opacity-100', card.dataset.year !== year);
    });
  }

  // Click on year scrolls to story
  yearItems.forEach((item) => {
    item.addEventListener('click', () => {
      const year = item.dataset.year;
      const targetCard = document.querySelector(`.story-card[data-year="${year}"]`);
      if (targetCard) {
        targetCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  scrollArrow.forEach((item) => {
    item.addEventListener('click', () => {
      const year = item.dataset.year;
      const targetCard = document.querySelector(`.story-card[data-year="${year}"]`);
      if (targetCard) {
        targetCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Intersection observer to highlight year based on scroll inside story section
  const cardObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          activateYear(entry.target.dataset.year);
        }
      });
    },
    {
      root: storySection,
      threshold: 0.6,
    }
  );

  storyCards.forEach((card) => cardObserver.observe(card));

  // Initialize
  activateYear('2017');

  const faders = document.querySelectorAll('.fade-in');

  const appearOptions = {
    threshold: 0.4,
    rootMargin: '0px 0px -50px 0px',
  };

  const appearOnScroll = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible'); // Fade in
      } else {
        entry.target.classList.remove('visible'); // Fade out
      }
    });
  }, appearOptions);

  faders.forEach((fader) => {
    appearOnScroll.observe(fader);
  });
});
document.querySelectorAll('.infinite-row .infinite-row__list').forEach((list) => {
  const items = Array.from(list.children).map((n) => n.cloneNode(true));
  items.forEach((n) => {
    n.setAttribute('aria-hidden', 'true');
    list.appendChild(n);
  });
});